import createCachedSelector from 're-reselect';

import type { YammerI18nState } from '../../state/types';
import { getCurrentLocale } from '../locales/selectors';

import type { DateTimeFormatType } from './shared';
import { dateTimeFormatOptionsMap } from './shared';

export const getDateTimeFormatter = createCachedSelector(
  getCurrentLocale,
  (_state: YammerI18nState, formatType: DateTimeFormatType) => formatType,
  (locale, formatType) => new Intl.DateTimeFormat(locale, dateTimeFormatOptionsMap[formatType])
)((_state, formatType) => formatType);
